/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeHeading4, BaSeParagraph, BaSeTheme } from '@base/react';
import React, { useContext } from 'react';

import * as Sebrae from '@sebrae/react-core';
import { useQuizProfileController } from '../../../../hooks/controllers/quiz-profile-controller';
import { useMessage } from '../../../../hooks/messages/useMessage';
import Button from '../button';
import { QuizProfileContext } from './context/QuizContext';
import { AlignDescription, ButtonWrapper, Content } from './quiz-profile-style';
import QuizQuestion from './quiz-questions';

const NEXT = 'AVANÇAR';
const BACK = 'VOLTAR';
const FINISH_AND_SEND = 'FINALIZAR E AVANÇAR';

function QuizStep({ data }) {
  const { handleChangeStep, currentStep, moduleSettings, user } =
    useContext(QuizProfileContext);
  const {
    getProfileStepByOrder,
    postQuizProfile,
    putProfileStepByAnswer,
    getProfileStepByIdInterview,
    postAnswerToQuizProfile,
    finishQuiz,
  } = useQuizProfileController();
  const { handleError, handleAttention } = useMessage();
  const { navigateTo } = Sebrae.useSebraeRouter();

  // const [moduleSettings, setModuleSettings] = React.useState({});
  const [quizHasCreate, setQuizHasCreate] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [quizData, setQuizData] = React.useState({});

  const { setSave, setPreviusStep } = React.useContext(QuizProfileContext);

  const [respostaStep, setRespostaStep] = React.useState({});
  const [respostaStepByOrder, setRespostaStepByOrder] = React.useState({});

  React.useEffect(() => {
    const handleStepByInterview = async () => {
      setLoading(true);
      try {
        const response = await getProfileStepByIdInterview(user.id);
        setLoading(false);
        if (response === undefined) {
          setQuizHasCreate(false);
          setSave(false);
          return;
        }

        setQuizHasCreate(true);
        const convertedData = {};

        response.collaboratorQuestions.forEach((item) => {
          const questionId = item.questionOption.question.id;

          convertedData[questionId] = {
            idCollaboratorQuestions: item.id,
            option: {
              id: item.questionOption.option.id,
            },
          };
        });

        setRespostaStep(convertedData);
        setQuizData(response);
      } catch (error) {
        console.log('error', error);
        setLoading(false);
      }
    };

    handleStepByInterview();
  }, [data.sequenceStep, getProfileStepByIdInterview, setSave, user]);

  React.useEffect(() => {
    if (quizData.id === undefined) return;
    setLoading(true);

    getProfileStepByOrder({
      idQuiz: quizData.id,
      order: data.sequenceStep,
    })
      .then((response) => {
        setLoading(false);

        if (response === undefined) {
          setQuizHasCreate(false);
          setSave(false);
          setRespostaStepByOrder({});
        } else {
          setRespostaStepByOrder(response);
        }
      })
      .catch(() => {
        setLoading(false);

        setQuizHasCreate(false);
      });
  }, [getProfileStepByOrder, data, setSave, quizData]);

  const valid = React.useCallback(
    (condition) => {
      if (condition) {
        handleAttention('Campo obrigatório não informado.');
        return true;
      }
      return false;
    },
    [handleAttention],
  );

  const handleSaveStep = React.useCallback(() => {
    if (data.sequenceStep === 2) {
      //se não tiver quiz criado ele chama o POST dde criar
      if (!quizHasCreate) {
        setSave(true);
        const questions = [];

        for (const key in respostaStep) {
          if (respostaStep.hasOwnProperty(key)) {
            questions.push({
              options: [respostaStep[key].option.id],
              id: +key,
            });
          }
        }

        const params = {
          emailCollaborator: user?.email,
          idInterview: user?.id,
          questions,
        };

        if (
          data.sequenceStep >= 2 &&
          valid(data.sequenceStep < 7 && questions.length < 10)
        ) {
          return;
        }
        if (valid(data.sequenceStep === 7 && questions.length < 5)) {
          return;
        }

        setLoading(true);
        postQuizProfile(params)
          .then((response) => {
            handleChangeStep(currentStep + 1);
            setSave(false);
          })
          .catch(() => {
            handleError('Erro ao salvar as respostas!');
            return;
          })
          .finally(() => setLoading(false));
      } else {
        handleChangeStep(currentStep + 1);
      }

      // se ja conter um quiz criado ele chama o POST de adicionar
      // respostas ao questionario
    }

    if (data.sequenceStep >= 3 && data.sequenceStep <= 7) {
      if (respostaStepByOrder?.collaboratorQuestions?.length > 0) {
        handleChangeStep(currentStep + 1);
        return;
      }

      const collaboratorQuestions = [];

      for (const key in respostaStep) {
        if (respostaStep.hasOwnProperty(key)) {
          if (respostaStep[key].idCollaboratorQuestions === undefined) {
            collaboratorQuestions.push({
              questionOption: {
                question: {
                  id: +key,
                },
                option: {
                  id: respostaStep[key].option.id,
                },
              },
            });
          }
        }
      }

      setSave(true);

      if (valid(data.sequenceStep <= 6 && collaboratorQuestions.length < 10)) {
        return;
      }

      if (valid(data.sequenceStep === 7 && collaboratorQuestions.length < 5)) {
        return;
      }

      const params = {
        collaboratorQuestions,
      };

      setLoading(true);
      postAnswerToQuizProfile(quizData.id, params)
        .then(() => {
          setSave(false);
          handleChangeStep(currentStep + 1);
        })
        .catch(() => {
          handleError('Erro ao salvar as respostas!');
          setLoading(false);
          return;
        })
        .finally(() => {
          setLoading(false);
          setSave(false);
        });
    }
  }, [
    data,
    quizHasCreate,
    setSave,
    user,
    valid,
    postQuizProfile,
    respostaStep,
    handleChangeStep,
    currentStep,
    handleError,
    respostaStepByOrder,
    postAnswerToQuizProfile,
    quizData,
  ]);

  const changeOption = React.useCallback(
    (params) => {
      putProfileStepByAnswer(quizData.id, params)
        .then((response) => console.log(response))
        .catch((error) => console.log(error));
    },
    [putProfileStepByAnswer, quizData],
  );

  const getUrl = React.useCallback(() => {
    const url = window.location.protocol + '//' + window.location.host;
    return url;
  }, []);

  const finish = React.useCallback(async () => {
    setSave(true);

    const url = `${getUrl()}/candidato/questionario/perfil/interview`;

    const collaboratorQuestions = [];

    for (const key in respostaStep) {
      if (respostaStep.hasOwnProperty(key)) {
        if (respostaStep[key].idCollaboratorQuestions === undefined) {
          collaboratorQuestions.push({
            questionOption: {
              question: {
                id: +key,
              },
              option: {
                id: respostaStep[key].option.id,
              },
            },
          });
        }
      }
    }

    const params = {
      collaboratorQuestions,
    };

    if (valid(data.sequenceStep === 8 && collaboratorQuestions.length < 6)) {
      return;
    }

    setLoading(true);
    // SALVANDO RESPOSTA DA ULTIMA PÁGINA
    postAnswerToQuizProfile(quizData.id, params)
      .then(() => {
        // SE SALVAR AS ULTIMAS RESPOSTA ENVIA O QUIZ E REDIRECIONA
        finishQuiz(quizData.id)
          .then((response) => {
            navigateTo(`${url}/sucesso`);
          })
          .catch((error) => {
            navigateTo(`${url}/falha`);
          });
        setSave(false);
        setLoading(false);
      })
      .catch((error) => {
        handleError('Erro ao salvar última resposta!');
        setLoading(false);
        return;
      });
  }, [
    setSave,
    getUrl,
    valid,
    data,
    postAnswerToQuizProfile,
    quizData,
    respostaStep,
    finishQuiz,
    navigateTo,
    handleError,
  ]);

  const handleSelectOption = React.useCallback(
    (questionId, optionId) => {
      setRespostaStep((prev) => {
        const hasQuestion = prev[questionId];

        if (
          hasQuestion !== undefined &&
          hasQuestion?.idCollaboratorQuestions !== undefined
        ) {
          const params = {
            collaboratorQuestion: {
              questionOption: {
                question: {
                  id: questionId,
                },
                option: {
                  id: optionId,
                },
              },
              id: hasQuestion.idCollaboratorQuestions,
            },
          };

          changeOption(params);
        }
        const newData = {
          ...prev,
          [questionId]: {
            ...prev[questionId],
            option: {
              id: optionId,
            },
          },
        };
        return newData;
      });
    },
    [changeOption],
  );

  return (
    <>
      <AlignDescription>
        <BaSeHeading4 color={BaSeTheme.colors.defaultColors.white}>
          {data?.description}
        </BaSeHeading4>
      </AlignDescription>

      <Content>
        {data?.sequenceStep < 8 && (
          <div style={{ marginBottom: 12 }}>
            <BaSeParagraph
              isBold
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              Selecione a opção que melhor descreve você em cada situação:
              Nunca, Raras vezes, Algumas vezes, Usualmente, Sempre
            </BaSeParagraph>
          </div>
        )}

        {data.questions.map((question) => (
          <QuizQuestion
            key={question.id}
            question={question}
            handleSelectOption={handleSelectOption}
            respostaStep={respostaStep}
            sequenceStep={data.sequenceStep}
          />
        ))}
      </Content>
      <ButtonWrapper>
        <>
          <Button
            calback={() => {
              handleChangeStep((prev) => prev - 1);
              setSave(false);
              setPreviusStep(currentStep);
            }}
            value={BACK}
            valueSmall={BACK}
            color={moduleSettings?.primaryColor}
            type="tertiary"
            withBorder={true}
            borderColor={moduleSettings?.primaryColor}
            disabled={loading}
          />
          <Button
            disabled={loading}
            calback={() =>
              data.sequenceStep === 8 ? finish() : handleSaveStep()
            }
            value={data.sequenceStep === 8 ? FINISH_AND_SEND : NEXT}
            valueSmall={data.sequenceStep === 8 ? FINISH_AND_SEND : NEXT}
            withBorder={true}
            color={moduleSettings?.tertiaryColor}
            borderColor={moduleSettings?.primaryColor}
          />
        </>
      </ButtonWrapper>
    </>
  );
}

export default QuizStep;
